import React from 'react';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink'; 
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';
import { IMainNavigationItem } from '../../HeaderComponent/HeaderComponent';

const NavBarLinks = ({ navBarLinks, pathForActiveNavLink }: { navBarLinks: IMainNavigationItem[], pathForActiveNavLink: string }) => (
    <ul className='SearchRibbon__list'>
        {navBarLinks.map((e, i) => (
            <li className='SearchRibbon__listItem' key={i}>
                <a
                    className={`SearchRibbon__listAnchor ${pathForActiveNavLink === e.link ? 'SearchRibbon__listAnchor--active' : ''}`}
                    href={`${e.link}${e.linkParam ? `${e.linkParam}` : ''}`}
                    target={e.linkNewTab ? '_blank' : '_self'}
                    rel='noreferrer'
                >
                    {transformHTMLParserLinks(wrapTrademarkSuperscript(e.linkTitle))}
                </a>
            </li>
        ))}
    </ul>
);

export default NavBarLinks;